const text = `
<p>Lorsque vous entrez votre texte, vérifiez l’orthographe et les accents des mots. DORÉBU peut avoir des difficultés à générer certains mots comme les noms propres et les anglicismes. Pour des raisons esthétiques, certains sons (comme les é / è) sont approximatifs.</p>
`;

const title = 'AIDE';

export default { text, title };
